(function () {
  var STORAGE_KEY = 'dusk_wishlist_seen';
  var STATE_ATTR = 'data-wishlist-state';

  function qsAll(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setSeen() { try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { } }
  function hasSeen() { try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; } }

  // Inject CSS for hiding related elements
  (function injectStyles() {
    var css = '.wishlist-hidden { display: none !important; }';
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
  })();

  function getAccountUrl() {
    var summary = document.querySelector('[data-account-summary]');
    return summary?.getAttribute('data-account-url') || '/account';
  }

  function isMobile() {
    try { return window.matchMedia && window.matchMedia('(max-width: 989px)').matches; } catch (e) { return false; }
  }

  function ensureDirectAccountLink() {
    if (!isMobile()) return;
    var details = document.querySelector('details.account-dropdown[data-account-dropdown]');
    if (!details) return;

    if (!details.__convertedToLink) {
      var accountUrl = getAccountUrl();
      var link = document.createElement('a');
      link.className = 'header__icon header__icon--account link focus-inset';
      link.setAttribute('aria-label', 'Account');
      link.href = accountUrl;
      var icon = details.querySelector('summary .icon-account, summary svg, summary span');
      if (icon) {
        link.innerHTML = details.querySelector('summary').innerHTML;
      } else {
        link.textContent = 'Account';
      }

      details.parentNode.insertBefore(link, details);
      details.style.setProperty('display', 'none', 'important');
      details.__convertedToLink = true;
      link.__injectedAccountLink = true;
    }
  }

  function restoreAccountDropdown() {
    var details = document.querySelector('details.account-dropdown[data-account-dropdown]');
    if (!details) return;
    details.style.display = '';
    var prev = details.previousElementSibling;
    if (prev && prev.__injectedAccountLink) {
      prev.parentNode.removeChild(prev);
    }
  }

  function setWishlistVisibility(show) {
    var root = document.documentElement;
    root.setAttribute(STATE_ATTR, show ? 'show' : 'hide');

    qsAll('[data-wishlist-entry]').forEach(function (el) {
      if (show) {
        el.classList.remove('wishlist-hidden');
        el.removeAttribute('aria-hidden');
      } else {
        el.classList.add('wishlist-hidden');
        el.setAttribute('aria-hidden', 'true');
      }
    });

    if (isMobile()) {
      if (show) {
        restoreAccountDropdown();
      } else {
        ensureDirectAccountLink();
      }
    }
  }

  function computeInitialState() {
    var forceShow = hasSeen();
    return { show: forceShow, source: forceShow ? 'seen' : 'default' };
  }

  function attachSeenListeners() {
    qsAll('[data-wishlist-entry]').forEach(function (el) {
      if (el.dataset.wishlistListening) return;
      el.addEventListener('click', function () {
        setSeen();
        setWishlistVisibility(true);
      }, { capture: true, passive: true });
      el.dataset.wishlistListening = 'true';
    });
  }

  window.WishlistAB = {
    setVariant: function (mode) {
      if (mode === 'show') {
         setSeen();
         setWishlistVisibility(true);
      } else if (hasSeen()) {
        setWishlistVisibility(true);
      } else {
        setWishlistVisibility(false);
      }
    },
    forceShow: function () { setSeen(); setWishlistVisibility(true); },
    setSeen: function () { setSeen(); setWishlistVisibility(true); },
    clearSeen: function () { localStorage.removeItem(STORAGE_KEY); },
    hasSeen: hasSeen,
    refresh: function () {
      attachSeenListeners();
      var init = computeInitialState();
      setWishlistVisibility(init.show);

      // Re-initialize Swym buttons for new DOM elements
      setTimeout(function() {
        function initSwym(swat) {
          var buttons = document.querySelectorAll('.swym-add-to-wishlist:not(.swym-loaded)');
          buttons.forEach(function(btn) {
            var parent = btn.parentNode;
            
            // Update variant ID to currently selected variant before re-initializing
            var currentVariantId = getCurrentVariantId();
            if (currentVariantId && btn.getAttribute('data-variant-id') !== currentVariantId) {
              btn.setAttribute('data-variant-id', currentVariantId);
              btn.setAttribute('data-empi', currentVariantId);
            }
            
            if (typeof swat.initializeActionButtons === 'function') {
               // Ensure parent has an ID for the selector
               if (!parent.id) {
                   parent.id = 'swym-reinit-' + Math.random().toString(36).substr(2, 9);
               }
               try {
                 swat.initializeActionButtons('#' + parent.id);
               } catch(e) {
                 console.error('WishlistAB: Failed to re-init', e);
               }
            }
          });
        }
        
        // Helper function to get currently selected variant ID
        function getCurrentVariantId() {
          var variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]:checked') ||
                           document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
                           document.querySelector('[data-selected-variant-id]');
          
          if (variantInput) {
            return variantInput.value || variantInput.getAttribute('data-selected-variant-id');
          }
          
          var productForm = document.querySelector('product-form');
          if (productForm && productForm.currentVariant) {
            return productForm.currentVariant.id.toString();
          }
          
          return null;
        }
        
        if (window._swat) {
          initSwym(window._swat);
        } else if (window.SwymCallbacks) {
          window.SwymCallbacks.push(initSwym);
        }
      }, 100);
    }
  };

  document.addEventListener('product:swapped', function() {
    window.WishlistAB?.refresh();
  });

  document.addEventListener('variant:change', function(e) {
    var wishlistButton = document.querySelector('.swym-add-to-wishlist[data-variant-id]');
    if (wishlistButton && e.detail && e.detail.variant) {
      wishlistButton.setAttribute('data-variant-id', e.detail.variant.id);
      wishlistButton.setAttribute('data-empi', e.detail.variant.id);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    attachSeenListeners();
    var init = computeInitialState();
    setWishlistVisibility(init.show);
  });
})();
